import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { LumaService, LumaCampaign } from '../luma.service';
import { Inject } from '@angular/core';

@Component({
  selector: 'app-luma-campaigns-list',
  templateUrl: './campaigns-list.component.html',
  styleUrls: ['./campaigns-list.component.scss']
})
export class CampaignsListComponent implements OnInit {
  displayedColumns: string[] = ['name', 'status', 'created_at', 'updated_at', 'stats', 'actions'];
  dataSource = new MatTableDataSource<LumaCampaign>([]);
  isLoading = false;
  statsHeader = 'Stats (Recip/Gen)';
  sendgridEnabled = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(@Inject(LumaService) private lumaService: LumaService, private router: Router) {}

  ngOnInit(): void {
    this.lumaService.isSendgridEnabled().subscribe(r => {
      this.sendgridEnabled = !!r?.enabled;
      this.statsHeader = this.sendgridEnabled ? 'Stats (Recip/Gen/Sent)' : 'Stats (Recip/Gen)';
    });
    this.loadCampaigns();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  loadCampaigns(): void {
    this.isLoading = true;
    this.lumaService.listCampaigns().subscribe({
      next: (records) => {
        this.dataSource.data = records;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  createCampaign(): void {
    this.router.navigate(['/luma', 'create']);
  }

  viewCampaign(row: LumaCampaign): void {
    this.router.navigate(['/luma', row.id]);
  }

  editCampaign(row: LumaCampaign): void {
    if (row.status === 'pending_send' || row.status === 'send_complete') { return; }
    this.router.navigate(['/luma', row.id, 'edit']);
  }

  duplicateCampaign(row: LumaCampaign): void {
    this.lumaService.getCampaign(row.id).subscribe((c) => {
      this.router.navigate(['/luma', 'create'], { state: { duplicateFrom: c } });
    });
  }

  deleteCampaign(row: LumaCampaign): void {
    this.lumaService.deleteCampaign(row.id).subscribe(() => this.loadCampaigns());
  }

  canDownload(row: LumaCampaign): boolean {
    return row.status === 'generation_complete' || row.status === 'send_complete';
  }

  downloadCampaign(row: LumaCampaign, format: 'csv' | 'xlsx' | 'eml'): void {
    if (!this.canDownload(row)) { return; }
    this.lumaService.downloadZip(row.id, format);
  }
}


